import { render, staticRenderFns } from "./choix-du-contrat.vue?vue&type=template&id=55b67204"
import script from "./choix-du-contrat.vue?vue&type=script&lang=ts"
export * from "./choix-du-contrat.vue?vue&type=script&lang=ts"
import style0 from "./choix-du-contrat.vue?vue&type=style&index=0&id=55b67204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports